import type { Ssm5RecentConnection } from '@packages/domain/ssm5';

import { GetRecentConnection } from '@packages/domain/ssm5';
import { container } from '@web/services/container';

import { useLookup } from './use-lookup';

const [$getRecentConnection] = container.resolveOperations(GetRecentConnection);

/**
 * The most recent eligible SSM5 connection of the given VIN.
 *
 * @param vin - the VIN of the open VIN session, or undefined without one
 * @returns the connection once looked up; undefined without one, while loading, or when the lookup fails
 */
export function useRecentConnection(vin: string | undefined): Ssm5RecentConnection | undefined {
    return useLookup(vin, lookupRecentConnection);
}

/**
 * Look the VIN's most recent eligible connection up.
 *
 * @param vin - the VIN whose connections are searched
 * @param signal - aborts the lookup
 * @returns the connection, or undefined when the VIN has none
 */
function lookupRecentConnection(vin: string, signal: AbortSignal): Promise<Ssm5RecentConnection | undefined> {
    return $getRecentConnection({ signal, vin });
}
